module.exports = "pegasus_template/assets/preview-19.png";